import React from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { WeeklyStrategy, StrategyPhase } from '../../ProfitScenario/types';

const { Text } = Typography;

interface WeekColumnProps {
    week: WeeklyStrategy;
    phase: StrategyPhase;
}

export const WeekColumn: React.FC<WeekColumnProps> = ({ week, phase }) => {
    const daysInWeek = week.weekNumber === 13 ? 6 : 7;
    let dateRange = '';
    if (phase.startDate) {
        const phaseStart = dayjs(phase.startDate);
        const weekOffset = week.weekNumber - phase.startWeek;
        const weekStart = phaseStart.add(weekOffset * 7, 'day');
        const weekEnd = weekStart.add(daysInWeek - 1, 'day');
        dateRange = `${weekStart.format('MM/DD')}-${weekEnd.format('MM/DD')}`;
    }

    return (
        <div>
            <div><Text strong style={{ fontSize: 15 }}>W{week.weekNumber}</Text> <Text type="secondary" style={{ fontSize: 12 }}>({daysInWeek}天)</Text></div>
            {dateRange && <div style={{ fontSize: 11, color: '#1890ff' }}>{dateRange}</div>}
        </div>
    );
};
